// Mock data for Ask Away Accounting

export const company = {
  name: "Ask Away Accounting",
  tagline: "Affordable accounting solutions with a low fee promise",
  shortTagline: "Less hassle. More clarity.",
  phone: "06 376 5632",
  email: "askaway@xtra.co.nz",
  address: "81 Vogel Street, Woodville 4920",
  region: "Tararua & Manawatu",
  hours: [
    { day: "Monday – Thursday", time: "8:30am – 5:00pm" },
    { day: "Friday", time: "8:30am – 4:00pm" },
    { day: "Saturday – Sunday", time: "Closed" },
  ],
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why-us" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const heroPoints = [
  "Free no-obligation initial consultation",
  "Low fee promise — no hidden surprises",
  "Servicing clients all over New Zealand",
];

export const services = [
  {
    id: "accounting",
    icon: "Calculator",
    title: "Accounting Services",
    description:
      "End of year accounts, income tax returns, GST, payroll and profit & loss reporting done right.",
    items: [
      "End of Year Accounts",
      "Income Tax Returns",
      "GST Returns – 2-monthly, 6-monthly or annual",
      "Payroll & PAYE",
      "Profit & Loss Reports",
    ],
  },
  {
    id: "farming",
    icon: "Tractor",
    title: "Farming & Rural",
    description:
      "Specialist accounting for farms and rural businesses — we understand the land you work on.",
    items: [
      "Rural accounting services",
      "Herd Scheme calculations",
      "National Standard Cost calculations",
      "Livestock valuations",
    ],
  },
  {
    id: "property",
    icon: "Home",
    title: "Property Investments",
    description:
      "Let us look after the numbers on your rental properties so you can keep building your portfolio.",
    items: [
      "Rental property end of year tax returns",
      "Investment property reporting",
      "Depreciation schedules",
      "Brightline test guidance",
    ],
  },
  {
    id: "business",
    icon: "Briefcase",
    title: "Business Support",
    description:
      "From choosing the right entity to cloud accounting setup — we help your business move forward.",
    items: [
      "Choosing the right business entity",
      "Cloud accounting setup (Xero, MYOB)",
      "Cashflow forecasting",
      "Business advisory & KPIs",
    ],
  },
];

export const valueProps = [
  {
    icon: "Clock",
    title: "Save Time & Money",
    text: "Affordable accounting with no hidden costs or surprises. Just clear pricing and great service.",
  },
  {
    icon: "Coffee",
    title: "Free Initial Consultation",
    text: "Meet with us to chat through your accounting needs — no obligation, no charge.",
  },
  {
    icon: "Rocket",
    title: "Focus on Your Business",
    text: "We take care of the accounts so you can spend your energy on running your business.",
  },
  {
    icon: "MapPin",
    title: "Local & Nationwide",
    text: "Based in Woodville, working with clients across the Tararua, Manawatu and all of NZ.",
  },
];

export const stats = [
  { value: "20+", label: "Years' experience" },
  { value: "350+", label: "Happy clients" },
  { value: "100%", label: "NZ owned" },
  { value: "$0", label: "Initial consult" },
];

export const testimonials = [
  {
    name: "Sarah M.",
    role: "Café Owner, Pahiatua",
    quote:
      "The team made GST and payroll so simple. I finally feel on top of my numbers, and the fees are honestly the best I've seen in the region.",
  },
  {
    name: "Dave R.",
    role: "Dairy Farmer, Dannevirke",
    quote:
      "They actually understand farming. Herd scheme, livestock, the lot — they explain it in plain Kiwi English and just get on with it.",
  },
  {
    name: "Linda & Pete",
    role: "Property Investors, Palmerston North",
    quote:
      "We've grown from one rental to five and Ask Away has been with us the whole way. Friendly, prompt and they always pick up the phone.",
  },
  {
    name: "Marcus T.",
    role: "Sole Trader, Ashhurst",
    quote:
      "Switched from a big-city firm and saved a fortune without losing any quality. The free initial chat sold me — these guys care.",
  },
];

export const faqs = [
  {
    q: "Do I need to be local to work with you?",
    a: "Not at all. We work with clients all over New Zealand using cloud accounting tools like Xero and MYOB. Whether you're in Woodville or Auckland, we've got you covered.",
  },
  {
    q: "What does the free initial consultation include?",
    a: "A relaxed chat about your business, current accounting setup, what's working and what isn't. There's no charge and no obligation to use our services afterwards.",
  },
  {
    q: "How much do you charge?",
    a: "Our low fee promise means transparent pricing with no surprises. Fees depend on the work involved, but we'll always quote up front so you know exactly where you stand.",
  },
  {
    q: "Can you help me switch from another accountant?",
    a: "Yes — switching is easier than most people think. We handle the handover with your previous accountant so you barely have to lift a finger.",
  },
  {
    q: "Do you only work with small businesses?",
    a: "We work with sole traders, small to medium businesses, farms, property investors and rural operators. If you've got numbers to look after, we can help.",
  },
];

export const images = {
  hero: "https://images.unsplash.com/photo-1762427354051-a9bdb181ae3b?auto=format&fit=crop&w=1200&q=80",
  services: "https://images.unsplash.com/photo-1626266061368-46a8f578ddd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjYWxjdWxhdG9yJTIwZmluYW5jZXxlbnwwfHx8fDE3ODIwNzI5OTl8MA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1713461983836-de0a45009424?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxhY2NvdW50YW50JTIwb2ZmaWNlfGVufDB8fHx8MTc4MjA3Mjk5OXww&ixlib=rb-4.1.0&q=85",
  farm: "https://images.pexels.com/photos/35470977/pexels-photo-35470977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  property: "https://images.unsplash.com/photo-1613520806140-a7463f162542?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxOZXclMjBaZWFsYW5kJTIwaG91c2V8ZW58MHx8fHwxNzgyMDczMDA2fDA&ixlib=rb-4.1.0&q=85",
  team: "https://images.pexels.com/photos/36733304/pexels-photo-36733304.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ruralLandscape: "https://images.unsplash.com/photo-1470093014438-2ede8d7a4818?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxOZXclMjBaZWFsYW5kJTIwZmFybXxlbnwwfHx8fDE3ODIwNzI5OTl8MA&ixlib=rb-4.1.0&q=85",
};
